import { render, staticRenderFns } from "./IconSvgZONTAMyZonta.vue?vue&type=template&id=0281866a&scoped=true&"
import script from "./IconSvgZONTAMyZonta.vue?vue&type=script&lang=js&"
export * from "./IconSvgZONTAMyZonta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281866a",
  null
  
)

export default component.exports